import React, {useEffect} from "react";

import Modal from '@material-ui/core/Modal';

import FormHelperText from '@material-ui/core/FormHelperText';

import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

import Button from "@material-ui/core/Button";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import {CircularProgress, Grid} from "@material-ui/core";
import {useHistory, useParams} from "react-router-dom";

import {generateDynamicRoute} from "../../../utils/utils";
import {AdminUtilisateursModifierGroupePage} from "../../../routes/administratorRoutes";
import {
    adminUtilisateursFetchGroupeListeGroupes, adminUtilisateursFetchGroupeListeUtilisateurs,
    adminUtilisateursFetchListeGroupes
} from "../../../store/actions/admin/utilisateurs/listeGroupesActions";
import {connect} from "react-redux";
import Chip from "@material-ui/core/Chip";


import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';



import DateFnsUtils from '@date-io/date-fns';

import {
    DateTimePicker,
    MuiPickersUtilsProvider,
} from '@material-ui/pickers';

import Alert from "@material-ui/lab/Alert";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import TreeListeGroupesSingleAdd from "../../../components/TreeListeGroupesSingleAdd";
import Box from "@material-ui/core/Box";
import TreeListeGroupesMultiAdd from "../../../components/TreeListeGroupesMultiAdd";
import {adminCoursFetchListeCours} from "../../../store/actions/admin/cours/listeCoursActions";
import TreeListe from "../../../components/TreeListe";
import {
    adminCoursFetchCategorieListeCategories, adminCoursFetchCategorieListeCours,
    adminCoursFetchListeCategories
} from "../../../store/actions/admin/cours/listeCategoriesActions";
import {
    adminAssignementsGroupeCategorieAjouterAssignementGroupeCategorie,
    adminAssignementsGroupeCategorieAjouterAssignementGroupeCategorieReset
} from "../../../store/actions/admin/assignementsGroupeCategorie/ajouterAssignementGroupeCategorieActions";

const initialState = {
    groupe: {value : null, error : null},
    categorie: {value : null, error : null},
    role: {value : null, error : null} ,
    dateDebutEnabled : false,
    dateDebut : new Date(),
    dateFinEnabled : false,
    dateFin : new Date(),
    groupesExpanded : false,
    categoriesExpanded : false
};

function AjouterAssignementGroupeCategorieModal(props) {


    const history = useHistory();

    let { groupeId } = useParams();

    const handleGroupesExpanded = (event,isExpanded) => {
        setState(prevState => {
            return {
                ...prevState,
                groupesExpanded : isExpanded
            }
        });
    };

    const handleCategoriesExpanded = (event,isExpanded) => {
        setState(prevState => {
            return {
                ...prevState,
                categoriesExpanded : isExpanded
            }
        });
    };

    useEffect(() => {

        if(props.groupe.groupe) {
            setState(prevState => {
                return {
                    ...prevState,
                    groupe:{ value : props.groupe.groupe, error : null}
                }
            })
        }

    },[props.groupe.groupe]);


    useEffect(() => {
        props.fetchListeGroupes();
        props.fetchListeCategories();

        return () => {
            props.ajouterAssignementGroupeCategorieReset();
        }

    },[]);

    const [state, setState] = React.useState(initialState);

    const handleDateDebutChange = (date) => {
        setState(prevState => {
            return {
                ...prevState,
                dateDebut : date
            }
        })
    };
    const handleDateFinChange = (date) => {
        setState(prevState => {
            return {
                ...prevState,
                dateFin: date
            }
        })
    };

    const handleChangeRole = (event) => {
        const value = event.target.value;
        setState(prevState => {
            return {
                ...prevState,
                role : {value: value, error:null}
            }
        })
    };

    const handleChangeDateDebutEnabled = (event) => {
        const checked = event.target.checked;
        setState(prevState => {
            return {
                ...prevState,
                dateDebutEnabled: checked
            }
        });
    };

    const handleChangeDateFinEnabled = (event) => {
        const checked = event.target.checked;
        setState(prevState => {
            return {
                ...prevState,
                dateFinEnabled: checked
            }
        });
    };



    const handleClose = () => {

        history.push(generateDynamicRoute(AdminUtilisateursModifierGroupePage.path,[{toReplace:":groupeId",value:groupeId}]));

    };

    const formOnSubmitHandler = (event) => {

        event.preventDefault();

        let error = false;

        const groupe = state.groupe.value;
        const categorie = state.categorie.value;
        const role = state.role.value;

        if(!groupe) {
            error = true;
            setState(prevState => {
                return {
                    ...prevState,
                    groupe: {
                        value: null,
                        error : "Le groupe est obligatoire"
                    }
                }
            })
        }

        if(!categorie) {
            error = true;
            setState(prevState => {
                return {
                    ...prevState,
                    categorie: {
                        value: null,
                        error : "La categorie est obligatoire"
                    }
                }
            })
        }

        if(!role) {
            error = true;
            setState(prevState => {
                return {
                    ...prevState,
                    role: {
                        value: null,
                        error : "Le role est obligatoire"
                    }
                }
            })
        }

        if(!error) {

            const assignementGroupeCategorie = {
                groupe : {
                    id : groupe.id
                },
                categorie : {
                    id : categorie.id
                },
                role : role,
                dateDebut : state.dateDebutEnabled ? state.dateDebut : null,
                dateFin : state.dateFinEnabled ? state.dateFin : null
            };


            props.ajouterAssignementGroupeCategorie(assignementGroupeCategorie);
        }

    };

    const handleGroupeSelect = (groupe) => {
        setState(prevState => {
            return {
                ...prevState,
                groupe: {value : groupe, error : null }
            };
        });
    };

    const handleGroupeUnSelect = () => {
        setState(prevState => {
            return {
                ...prevState,
                groupe: {value : null, error : null }
            };
        });
    };

    const handleCategorieSelect = (categorie) => {
        setState(prevState => {
            return {
                ...prevState,
                categorie:{value : categorie, error : null}
            };
        });
    };

    const handleCategorieUnSelect = () => {
        setState(prevState => {
            return {
                ...prevState,
                categorie: {value: null, error :null}
            };
        });
    };


    const isCategorieSelected = (categorieToCheck) => {
        return state.categorie.value && state.categorie.value.id === categorieToCheck.id;
    };


    const isGroupeSelected = (groupeToCheck) => {
        return state.groupe.value && state.groupe.value.id === groupeToCheck.id;
    };


    return(
        <Modal
            open={true}
            onClose={handleClose}
            style={{overflowY:"auto"}}
        >
            <div style={{maxWidth:"700px", width:"100%"}} className={"bg-white text-center border rounded mx-auto my-5 p-3"}>

                <h2>Assigner un groupe à une categorie</h2>

                {props.assignementGroupeCategorie.error &&
                <Alert className={"mt-2 mb-3"} variant="filled" severity="error">{props.assignementGroupeCategorie.error}</Alert>
                }
                {props.assignementGroupeCategorie.success&&
                <Alert className={"mt-2 mb-3"} variant="filled" severity="success">L'assignement ajouté avec succees</Alert>
                }


                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <form className={"text-left p-4"} onSubmit={formOnSubmitHandler}>


                        <ExpansionPanel expanded={state.groupesExpanded} onChange={handleGroupesExpanded}>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                            >
                                <FormControl error={state.groupe.error ? true : false}>
                                <h6>Groupe : {!state.groupesExpanded && state.groupe.value ? <Chip label={state.groupe.value.nom} onDelete={handleGroupeUnSelect} /> : null}</h6>
                                    {state.groupe.error && <FormHelperText>{state.groupe.error}</FormHelperText>}
                                </FormControl>

                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails >
                                {props.listeGroupes.loading ?
                                    <CircularProgress size={50} thickness={4} />
                                    :
                                    <Grid container spacing={3}>

                                        <Grid item xs={12} md={8} >
                                            <span>Selectionner un groupe</span>

                                            <TreeListe fetchGroupeListeGroupes={props.fetchGroupeListeGroupes} selectable={"Groupe"} liste={props.listeGroupes.listeGroupes} onlyGroupes={true} handleSelect={handleGroupeSelect} handleUnSelect={handleGroupeUnSelect} isGroupeSelected={isGroupeSelected}/>

                                        </Grid>
                                        <Grid item xs={12} md={4} >
                                            <span>Groupe Selectionné</span>
                                            <Box>
                                                {state.groupe.value &&
                                                <Chip
                                                    label={state.groupe.value.nom}
                                                    onDelete={handleGroupeUnSelect}
                                                />}
                                            </Box>
                                        </Grid>

                                    </Grid>
                                }
                            </ExpansionPanelDetails>
                        </ExpansionPanel>




                    <ExpansionPanel expanded={state.categoriesExpanded} onChange={handleCategoriesExpanded}>
                        <ExpansionPanelSummary
                            expandIcon={<ExpandMoreIcon />}
                        >
                            <FormControl error={state.categorie.error ? true : false}>
                                <h6>Categorie : {!state.categoriesExpanded && state.categorie.value ? <Chip label={state.categorie.value.titre} onDelete={handleCategorieUnSelect} /> : null}</h6>
                                {state.categorie.error && <FormHelperText>{state.categorie.error}</FormHelperText>}
                            </FormControl>
                            </ExpansionPanelSummary>
                        <ExpansionPanelDetails >
                            {props.listeCategories.loading ?
                                <CircularProgress size={50} thickness={4} />
                                :
                                <Grid container spacing={3}>

                                    <Grid item xs={12} md={8} >
                                        <span>Selectionner une categorie</span>
                                        <TreeListe onlyCategories={true} fetchCategorieListeCategories={props.fetchCategorieListeCategories}  selectable={"Categorie"} liste={props.listeCategories.listeCategories} handleSelect={handleCategorieSelect} handleUnSelect={handleCategorieUnSelect} isCategorieSelected={isCategorieSelected}/>
                                    </Grid>
                                    <Grid item xs={12} md={4} >
                                        <span>Categorie Selectionné</span>
                                        <Box>
                                            {state.categorie.value &&
                                            <Chip
                                                label={state.categorie.value.titre}
                                                onDelete={handleCategorieUnSelect}
                                            />}
                                        </Box>
                                    </Grid>

                                </Grid>
                            }
                        </ExpansionPanelDetails>
                    </ExpansionPanel>



                    <FormControl error={state.role.error ? true : false} fullWidth={true} className={"my-3"}>
                        <InputLabel id="demo-simple-select-label">Role</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={state.role.value}
                            onChange={handleChangeRole}
                        >
                            <MenuItem value={'ROLE_APPRENANT'}>Apprenant</MenuItem>
                            <MenuItem value={'ROLE_ENSEIGNANT'}>Enseignant</MenuItem>
                        </Select>
                        {state.role.error && <FormHelperText>{state.role.error}</FormHelperText>}
                    </FormControl>


                    <FormControlLabel
                        control={<Switch checked={state.dateDebutEnabled} onChange={handleChangeDateDebutEnabled} />}
                        label="Avoir un date debut"
                    />

                    <br />
                    <DateTimePicker value={state.dateDebut}
                                    fullWidth={true}
                                    label="Date Debut"
                                    disabled={!state.dateDebutEnabled}
                                    disablePast
                                    ampm={false}
                                    format="yyyy/MM/dd HH:mm" inputVariant={"outlined"} onChange={handleDateDebutChange} />

                    <FormControlLabel
                        control={<Switch checked={state.dateFinEnabled} onChange={handleChangeDateFinEnabled} />}
                        label="Avoir un date fin"
                    />

                    <DateTimePicker value={state.dateDebut}
                                    fullWidth={true}
                                    label="Date Debut"
                                    disabled={!state.dateFinEnabled}
                                    disablePast
                                    ampm={false}
                                    format="yyyy/MM/dd HH:mm" inputVariant={"outlined"} onChange={handleDateFinChange} />

                                    <div className={"text-center"}>
                                        <Button disabled={props.assignementGroupeCategorie.loading} type={"submit"} className={"my-2"}
                                                color={"primary"} variant={"contained"} endIcon={<PersonAddIcon/>}>Ajouter</Button>
                                        {props.assignementGroupeCategorie.loading && <CircularProgress size={24} /*className={spinnerClasses.join(" ")}*/ />}
                                    </div>

                </form>
                </MuiPickersUtilsProvider>


            </div>
        </Modal>
    );




}

const mapStateToProps = (state) => {
    return {
        assignementGroupeCategorie : state.admin.assignementsGroupeCategorie.ajouterAssignementGroupeCategorie,
        groupe : state.admin.utilisateurs.groupe,
        listeGroupes : state.admin.utilisateurs.listeGroupes,
        listeCategories : state.admin.cours.listeCategories
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        ajouterAssignementGroupeCategorie : (assignementGroupeCategorie) => dispatch(adminAssignementsGroupeCategorieAjouterAssignementGroupeCategorie(assignementGroupeCategorie)),
        ajouterAssignementGroupeCategorieReset : () => dispatch(adminAssignementsGroupeCategorieAjouterAssignementGroupeCategorieReset()),
        fetchListeGroupes : () => dispatch(adminUtilisateursFetchListeGroupes()),
        fetchGroupeListeGroupes : (groupeId) => dispatch(adminUtilisateursFetchGroupeListeGroupes(groupeId)),

        fetchListeCategories : () => dispatch(adminCoursFetchListeCategories()),
        fetchCategorieListeCategories : (categorieId) => dispatch(adminCoursFetchCategorieListeCategories(categorieId))

    }
};

export default connect(mapStateToProps,mapDispatchToProps)(AjouterAssignementGroupeCategorieModal);